/* eslint-disable */
/*
 * @Description:
 * @Author: 梁平贤
 * @LastEditors: 梁平贤
 * @Date: 2019-06-16 09:41:38
 * @LastEditTime: 2019-10-16 11:16:31
 */
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

import CodeMirror from "codemirror/lib/codemirror";
(function(mod) {
  if (typeof exports === "object" && typeof module === "object") {
    mod(CodeMirror);
  } else if (typeof define === "function" && define.amd) {
    define(["codemirror/lib/codemirror"], mod);
  } else {
    mod(CodeMirror);
  }
})(function(CodeMirror) {
  "use strict";

  CodeMirror.defineMode("enfrytext", function() {
    return {
      token: function(stream, state) {
        stream.skipToEnd();
        return "null";
      }

    };
  });

  CodeMirror.defineMIME("text/x-enfrytext", "enfrytext");
});
